import * as go from 'gojs';

export const deleteAPI = (node: go.Node) => {
  if (!node?.diagram || !node.canDelete()) {
    return;
  }

  node.diagram.remove(node);
};
